import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReplyAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reply_all"}/>
}
